module.exports = __webpack_public_path__ + "static/media/banner.d7af48db.png";